export default __webpack_public_path__ + "static/media/embedded-link.bfada77b.svg";